import React from 'react';
import { motion } from 'framer-motion';

import banner2 from '../assets/banner2.png';

const PrivacyPolicy = () => {

  return (
    <div className="bg-white min-h-screen">
      {/* ================= HERO SECTION (Standard Theme) ================= */}
      <section
        className="relative py-16 md:py-24 text-center overflow-hidden"
        style={{
          backgroundImage: `url(${banner2})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <h3 className="relative z-10 font-syne text-[28px] md:text-[40px] text-slate-900 tracking-tight font-medium">
         Privacy Policy
        </h3>

        <div
          className="pointer-events-none absolute bottom-0 left-0 w-full h-[120px]"
          style={{
            background:
              "linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0.35) 40%, rgba(255,255,255,0.7) 70%, rgba(255,255,255,1) 100%)",
          }}
        />
      </section>

      {/* ================= CONNECT DETAILS SECTION ================= */}
   
{/* ================= PRIVACY CONTENT SECTION ================= */}
      <section className="py-16 bg-white">
        <div className="max-w-5xl mx-auto px-2 lg:px-4">
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="space-y-8 text-slate-700 leading-relaxed text-base md:text-lg"
          >
            {/* Introduction */}
            <div className="space-y-4">
              <p>
                This privacy policy sets out how DreamLadder Capital uses and protects any information that you share when you use this website. DreamLadder Capital is committed to ensuring that your privacy is protected at all times. Should we ask you to provide certain information by which you can be identified when using this website, you can be assured that it will only be used in accordance with this privacy statement.
              </p>
              <p>
                DreamLadder Capital may change this policy from time to time by updating this page. This policy is effective from 1 August 2025.
              </p>
              <p>
              DreamLadder Capital understands that our relationship is strongly built on trust and faith. In Course of using information on this website or availing the services, DreamLadder Capital may become privy to the personal information of its customer including information that is of confidential nature. DreamLadder Capital is strictly committed to protecting the privacy of its Customer and has taken reasonable measures to protect the confidentiality of the customer information and its transmission through World Wide Web. However it shall not be liable in any manner for disclosure of the confidential information in accordance with this Privacy Commitment or in terms of the agreement if any with the Customer or by reasons beyond its control. We may however be required to disclose your personal information to Government, Judicial bodies, and our Regulators or to any person to whom the Firm is under an obligation to make disclosure under the requirements of any law binding on the Firm or any of its branches, if required. Hyperlink Policy for user Any hyperlink to other Internet sites is at customer’s own risk. The contents of which and the accuracy of opinions expressed are not verified, monitored or endorsed by DreamLadder Capital, in any way or manner. DreamLadder Capital is not responsible for the setup of any hyperlink from a third party website to DreamLadder Capital.
              </p>
            </div>

           

            {/* What We Collect */}
            <div className="space-y-4">
              <h4 className="text-xl font-bold text-slate-900">What we collect</h4>
              {/* Added the requested line here */}
  <p className="text-slate-600">We may collect the following information:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Name and contact details</li>
                <li>Personal information, including date of birth, Aadhaar Number, and Permanent Account Number (PAN)</li>
                <li>Demographic information such as gender and income</li>
                <li>Other information that can help us improve our services</li>
              </ul>
            </div>

            {/* What we do with the information */}
            <div className="space-y-4">
              <h4 className="text-xl font-bold text-slate-900">What we do with the information we gather</h4>
              <ul className="list-disc pl-6 space-y-2">
                <li>To conduct Know-Your-Customer registration as required by SEBI and/or other regulatory bodies</li>
                <li>To perform compliance checks and keep/maintain internal records</li>
                <li>To use the information to improve our products and services</li>
                <li>To periodically send emails to your registered email address about your investments, or other information which we think you may find interesting.</li>
                <li>You will be free to unsubscribe from our mailing list at any time if you do not wish to receive such emails from us. From time-to-time, we may also use your information to contact you via phone or email for market research purposes.</li>
                <li>We will not sell, distribute or lease your personal information to third parties unless we are required to share such information under the terms and conditions of the products and services you avail, or we are required to do so by law.</li>
                
              </ul>
            </div>

            {/* Security */}
            <div className="space-y-4">
              <h4 className="text-xl font-bold text-slate-900">Security</h4>
              <p>
               We are committed to ensuring that your information is secure. In order to prevent unauthorised access or disclosure, we have put in place suitable physical, electronic and managerial procedures to safeguard and secure the information we collect online.
              </p>
            </div>

            {/* Third Party Links */}
            <div className="space-y-4">
              <h4 className="text-xl font-bold text-slate-900">Links to other websites</h4>
              <p>Our website may contain links to other websites of interest. However, once you have used these links to leave our site, you should note that we do not have any control over such third-party websites. Therefore, we cannot be responsible for the protection and privacy of any information which you provide whilst visiting such sites. You should exercise caution and look at the privacy statement applicable to the website in question.</p>
            </div>

            <div className="space-y-4">
              <h4 className="text-xl font-bold text-slate-900">Controlling your personal information</h4>
              <p>
                If you believe that any of your information with us is incorrect or incomplete, please email us as soon as possible. We will promptly correct any information found to be incorrect.
              </p>
            </div>

            {/* Security Certificates */}
            <div className="space-y-4">
              <h4 className="text-xl font-bold text-slate-900">Security certificates</h4>
              <p>
                DreamLadder Capital is an online financial services company. We fully recognise and understand the security implications of being a service provider with whom people trust their money. There are many safeguards we adopt in this regard – some of these are technical, and some are structural.
              </p>
            </div>

             <div className="space-y-4">
              <h4 className="text-xl font-bold text-slate-900">When it comes to data security, our goal is to ensure that:</h4>
              
              <ul className="list-disc pl-6 space-y-2">
                <li>Your data is stored safely and securely – passwords are one-way encrypted before being stored in the database for high security.</li>
                <li>All communication with you, or with mutual fund companies and other service providers – are encrypted using the highest standards.</li>
                <li>Your data is not shared with anyone, unless you have explicitly requested us to do so to fulfil a transaction request.</li>
                <li>To ensure that we achieve these goals, we have a variety of certifications/trust verifications in place for our firm, both from technical and legal/operational perspectives. All our communications are encrypted by 256-bit encryption, and our data is hosted with top-tier hosting service providers. Also, our data is continuously backed up to ensure continuity of operations.</li>
              </ul>
            </div>

          </motion.div>
        </div>
      </section>

    </div>
  );
};

export default PrivacyPolicy;